import React from 'react';
import { OverlayTrigger, Tooltip } from '@isyc-react/design/bootstrap';
import clsx from 'clsx';
import "./column-filters.scss";
export const defaultTableFilterType = 'insideLabel';
export const ColumnFilterTooltip = props => {
  const {
    children,
    enable,
    tooltip
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OverlayTrigger, {
    show: enable ? undefined : false,
    delay: {
      show: 500,
      hide: 0
    },
    placement: 'top',
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      className: "table-column-filter-tooltip"
    }, tooltip)
  }, children));
};
export const ColumnFilterContainer = props => {
  const {
    className,
    children,
    column,
    defaultFilterType = defaultTableFilterType
  } = props;
  const {
    filterTooltip,
    filterValue
  } = column;
  const mandatoryTooltip = defaultFilterType === 'placeholderLabel' && Boolean(filterValue);
  return /*#__PURE__*/React.createElement(React.Fragment, null, defaultFilterType === 'outsideLabel' ? /*#__PURE__*/React.createElement("div", {
    className: clsx('table-column-head-filter', className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-column-head-filter-header"
  }, column.render('Header')), children) : /*#__PURE__*/React.createElement(ColumnFilterTooltip, {
    tooltip: mandatoryTooltip ? column.render('Header') : filterTooltip === true ? column.render('Header') : filterTooltip,
    enable: mandatoryTooltip || Boolean(filterTooltip)
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('table-column-head-filter', className)
  }, children)));
};